import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import { DefaultButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { Card, Col, Row } from 'react-bootstrap';
import moment from 'moment';
import PropTypes from 'prop-types';
import CLabel from '../../../../components/Common/CLabel';
import { useGetContractPartie } from '../../../../hooks/component/sPay/useOfContractParties';
import { useDispatch, useSelector } from 'react-redux';
import { action_updateContractPartieSelected, action_updateContractPartieSelectedId, action_updateContractPartieSidePanelIsOpen } from '../../../../reducers/actions/PAY/actions';
import { enum_CONTACTPARTIE_POLINOMY_FORM_VIEW, enum_CONTRACT_PARTIE_SIDEPANELS_CONFIG, enum_CONTRACTPARTIE_PARENT_PONINOMY_TYPE } from '../../../../common/Dictionaries';
import TablePolynomyItem from '../../../../components/Products/sAdjustment/Polynomy/TablePolynomyItem';
import { __calculateTotalRestAdjustmentAmount } from '../../../../common/CommonFuctions';
import TablePolynomyItemNotAdjustment from '../../../../components/Products/sAdjustment/Polynomy/TablePolynomyItemNotAdjustment';
import { _handleDeletePolynomyClick } from '../../Events';
import { formatNumber, isNullOrEmpty, isNullUndefined, isNullUndefinedOrEmpty } from '../../../../common/Helpers';
import { useGetContractModificationMaintainer } from '../../../../hooks/services/sKPI/useOfContractModification';

const SidePanelViewContractPartie = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const {
        _contractPartieSelected: contractPartieSelected,
        _contractPartieSidePanelsConfig: contractPartieSidePanelsConfig,
        _contractFormPartieConfig: contractFormPartieConfig,
    } = useSelector((state) => state.contractPartiesState);

    const [listContractModification, setListContractModification] = useState(null);
    useGetContractModificationMaintainer(listContractModification, setListContractModification)

    const onDismissPanel = () => {
        dispatch(action_updateContractPartieSelectedId(null))
        dispatch(action_updateContractPartieSelected(null))
        dispatch(action_updateContractPartieSidePanelIsOpen(enum_CONTRACT_PARTIE_SIDEPANELS_CONFIG.IS_OPEN_PARTIE_VIEW, false))
    };

    const onClosePanel = () => {
        onDismissPanel();
    };

    const onRenderFooterContent = () => {
        return  <Row>
                    <Col xl={12}>
                        <DefaultButton onClick={ onClosePanel }>{ t('data-lang-btn-close') }</DefaultButton>
                    </Col>
                </Row>
    }

    const totalRestAdjustmentAmount = __calculateTotalRestAdjustmentAmount(contractPartieSelected.l_POLINOMIO);

    return (
        <div>
            <Panel
                isOpen={ contractPartieSidePanelsConfig.isPanelViewPartieOpen }
                isBlocking={true}
                onDismiss={ onDismissPanel }
                headerText={ t('data-lang-boxname-partieform') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ PanelType.medium }
                type={ PanelType.medium }
            >
                {
                     contractPartieSelected.iteM_PARTIDA &&
                     <div>
                         <div>
                            <div style={{borderBottom: "1px solid #999"}}><h5>{ t('data-lang-lbl-contractpartie-partieinformation') }</h5></div>
                            <Row>
                                 <Col xs={12} xl={6}>
                                     <CLabel labelText={ t('data-lang-lbl-contractpartie-partienumber') } labelValue={ contractPartieSelected.iteM_PARTIDA.nroPartida } />
                                 </Col>
                                 <Col xs={12} xl={6} className="mt-1">
                                     <CLabel labelText={ t('data-lang-lbl-contractpartie-partiecode') } labelValue={ contractPartieSelected.iteM_PARTIDA.codigoPartida } />
                                 </Col>
                             </Row>
                             <Row>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-partiename') } labelValue={ contractPartieSelected.iteM_PARTIDA.nombrePartida } />
                                </Col>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-partieclass') } labelValue={ contractPartieSelected.iteM_PARTIDA.clasePartidaTitle } />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-partietype') } labelValue={ contractPartieSelected.iteM_PARTIDA.tipoPartidaTitle } />
                                </Col>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-partiecurrency') } labelValue={ contractPartieSelected.iteM_PARTIDA.monedaPartida } />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-partiestartmonth') } labelValue={ contractPartieSelected.iteM_PARTIDA.mesInicioPartida } />
                                </Col>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-partieendmonth') } labelValue={ contractPartieSelected.iteM_PARTIDA.mesTerminoPartida } />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-partieprevmonth') } labelValue={ contractPartieSelected.iteM_PARTIDA.mesPrevio } />
                                </Col>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-partieprevmonthexpensebase') } labelValue={ !isNullOrEmpty(contractPartieSelected.iteM_PARTIDA.gastoPrevioBasePartida) ? formatNumber(contractPartieSelected.iteM_PARTIDA.gastoPrevioBasePartida, 10) : "" } />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-partieprevexpensemonthadjunst') } labelValue={ !isNullOrEmpty(contractPartieSelected.iteM_PARTIDA.gastoPrevioReajustePartida) ? formatNumber(contractPartieSelected.iteM_PARTIDA.gastoPrevioReajustePartida, 10) : "" } />
                                </Col>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-partieprevexpensedifference') } labelValue={ !isNullOrEmpty(contractPartieSelected.iteM_PARTIDA.gastoPrevioDiftcPartidaMc) ? formatNumber(contractPartieSelected.iteM_PARTIDA.gastoPrevioDiftcPartidaMc, 10) : "" } />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-partietotalmonth') } labelValue={ !isNullOrEmpty(contractPartieSelected.iteM_PARTIDA.montoTotalPartida) ? formatNumber(contractPartieSelected.iteM_PARTIDA.montoTotalPartida, 10) : "" } />
                                </Col>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-partiecontractualmodifications') } labelValue={ !isNullUndefined(listContractModification) ? (!isNullUndefined(contractPartieSelected.iteM_PARTIDA.mcNombre) ? contractPartieSelected.iteM_PARTIDA.mcNombre : (!isNullUndefined(listContractModification.find(x => x.id === contractPartieSelected.iteM_PARTIDA.idMcContrato)) ? listContractModification.find(x => x.id === contractPartieSelected.iteM_PARTIDA.idMcContrato).changeCode : "")) : "" } />
                                </Col>
                            </Row>
                        </div>
                        <div>
                            <div style={{borderBottom: "1px solid #999"}}><h5>{ t('data-lang-lbl-contractpartie-aditionalinfo') }</h5></div>
                            <Row>
                                <Col xs={12} xl={6}>
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-serviceunit') } labelValue={ contractPartieSelected.iteM_PARTIDA.unidadPartidaTitle } />
                                </Col>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-totalserviceamount') } labelValue={ contractPartieSelected.iteM_PARTIDA.cantidadTotalServicio } />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-totalamountsumalz') } labelValue={ !isNullOrEmpty(contractPartieSelected.iteM_PARTIDA.montoTotalSumaAlzadaPartida) ? formatNumber(contractPartieSelected.iteM_PARTIDA.montoTotalSumaAlzadaPartida, 10) : "" } />
                                </Col>
                                <Col xs={12} xl={6} className="mt-1 d-none">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-partie') } labelValue="" />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-prevserviceamount') } labelValue={ contractPartieSelected.iteM_PARTIDA.cantidadPreviaServicio } />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-internalcode') } labelValue={ !isNullUndefined(contractPartieSelected.iteM_PARTIDA.codigoInterno) ? contractPartieSelected.iteM_PARTIDA.codigoInterno : t('no-data') } />
                                </Col>
                            </Row>
                        </div>
                        <Row>
                            {
                                contractPartieSelected.l_POLINOMIO && contractPartieSelected.l_POLINOMIO.map((polynomy, index) => (
                                    <Col xl={6}>
                                        <TablePolynomyItem
                                            key={index}
                                            parentId={contractPartieSelected.iteM_PARTIDA.id}
                                            parentPolinomyType={enum_CONTRACTPARTIE_PARENT_PONINOMY_TYPE.PARTIE}
                                            tableItem={polynomy}
                                            polynomyViewType={enum_CONTACTPARTIE_POLINOMY_FORM_VIEW.COMPLEX_EDIT}
                                            addCardWidth={false}
                                            handleDeletePolynomy={_handleDeletePolynomyClick}
                                        />
                                    </Col>
                                ))
                            }
                            {
                                totalRestAdjustmentAmount > 0 &&
                                <TablePolynomyItemNotAdjustment totalRestAdjustmentAmount={totalRestAdjustmentAmount} addCardWidth={false} />
                            }
                        </Row>
                    </div>
                }
            </Panel>
        </div>
    );
};

SidePanelViewContractPartie.propTypes = {
};

export default SidePanelViewContractPartie;